<template>
  <div class="vx-row justify-content-center mt-1 mb-2">

    <div class="vx-col w-1/3">
      <div class="justify-content-center">
        <div class="w-full p-1">
          <vs-progress class="items-left" :height="6" :percent="relationship" color="#9DCD5B"></vs-progress>
          <div class="w-full text-center">
            <span style="font-size: 0.8rem;">{{relationship}}% {{ $t("coach.coachingExperienceChart.cec1") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/3">
      <div class="justify-content-center">
        <div class="w-full p-1">
          <vs-progress class="items-left" :height="6" :percent="resourceAvailability" color="#76C488"></vs-progress>
          <div class="w-full text-center">
            <span style="font-size: 0.8rem;">{{resourceAvailability}}% {{ $t("coach.coachingExperienceChart.cec2") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/3">
      <div class="justify-content-center">
        <div class="w-full p-1">
          <vs-progress class="items-left" :height="6" :percent="managerSupport" color="#079E9A"></vs-progress>
          <div class="w-full text-center">
            <span style="font-size: 0.8rem;">{{managerSupport}}% {{ $t("coach.coachingExperienceChart.cec3") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ProgressMeasureHorizontal",
  props: ["managerSupport", "relationship", "resourceAvailability"],
  components: {},
  methods: {},
  // props: ['relevancy', 'progress', 'practice'],
  data() {
    return {
      fill: { gradient: ["green"] }
      /*rel: [this.relevancy],
      prog: [this.progress],
      prac: [this.practice]*/
    };
  }
};
</script>

<style scoped>
.justify-content-center {
  justify-content: center;
}

.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
</style>
